<template>
  <div
    class="gl-status-chip"
    :class="`gl-status-chip--${type}`"
    v-on="$listeners"
  >
    <div
      v-if="$slots.icon"
      class="gl-status-chip__icon"
    >
      <slot name="icon" />
    </div>

    <span class="gl-status-chip__label">
      <slot />
    </span>
  </div>
</template>

<script>
export default {
  name: 'GlStatusChip',
  props: {
    type: {
      type: String,
      default: 'info',
      validator: value => ['brand', 'info', 'warning'].includes(value),
    },
  },
}
</script>

<style scoped>
.gl-status-chip {
  display: inline-flex;
  padding: 3px;
  align-items: center;
  gap: 2px;
  border-radius: 4px;
  transition: all 0.2s ease;
  user-select: none;
}

.gl-status-chip__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.gl-status-chip__label {
  font-size: var(--Size-M, 14px);
  font-weight: 600;
  line-height: var(--Line-Height-L, 20px);
  letter-spacing: var(--Letter-Spacing-S, -0.2px);
}

.gl-status-chip--brand {
  background: rgba(25, 75, 251, 0.1);
  color: var(--Brand-Main);
}

.gl-status-chip--info {
  background-color: var(--Basic-100);
}

.gl-status-chip--warning {
  color: var(--Warning-Main);
  background: var(--Warning-100, rgba(255, 163, 5, 0.1));
}

.gl-status-chip[onclick],
.gl-status-chip:active {
  filter: brightness(0.95);
}
</style>
